import { SET_LOGIN, LoginActions } from "../types";

/**
 * Manage login state
 */



export default function (state = false, action: LoginActions): boolean {
  switch (action.type) {
    case SET_LOGIN:
      return action.login;
    default:
      return state;
  }
}
